import api from '../../lib/api';
import { url_api_v1_hmu_kit_get, url_api_v1_hmu_kit_doc_add, url_api_v1_hmu_kit_doc_remove, url_api_v1_hmu_kit_doc_markfeatured } from '../../lib/apiUrl';
import { HmuKitDocumentModel } from '../submission_kits/components/KitModels';

class HmuKitService {
  getHmuKitDocuments = async () => {
    try {
      const url = url_api_v1_hmu_kit_get;
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in getting hair & make-up kit documents.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  addInHmuKitDocument = async (kit_id: any, tag: string) => {
    try {
      const url = url_api_v1_hmu_kit_doc_add;
      const response = await api.post(url, {
        kit_document_id: kit_id,
        tag: tag,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in adding media in hair & make-up kit.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  
  deleteFromHmuKitDocument = async (hmuKitDocument: HmuKitDocumentModel) => {
    try {
      const url = url_api_v1_hmu_kit_doc_remove;
      const response = await api.post(url, {
        id: hmuKitDocument.id,
        hair_make_up_kit_id: hmuKitDocument.hair_make_up_kit_id,
        kit_document_id: hmuKitDocument.kit_document_id,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error removing media from hair & make-up kit.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
    markKitAsFeatured = async (hmu_kit_id: number, kit_document_id: number, featured:boolean) => {
      try {
        const url = url_api_v1_hmu_kit_doc_markfeatured;
        const response = await api.put(url, {
          hmu_kit_id: hmu_kit_id,
          kit_document_id: kit_document_id,
          featured: featured?'1':'0',
        });
        if (response.status !== 200 && response.status !== 201) {
          throw new Error('Error removing media from wardrobe kit.');
        }
        return true;
      } catch (error) {
        throw error;
      }
    };
}

const hmuKitService = new HmuKitService();

export default hmuKitService;

